import React from "react";
import { API } from "@/lib/apiClient";
import { DownloadSimple } from "@phosphor-icons/react";

// Downloads a CSV export using the httpOnly session cookie.
// When `render` is supplied, delegates rendering to the caller (e.g. BC ribbon).
export function CsvExport({ resource, filename, testid, render }) {
  const download = async () => {
    const res = await fetch(`${API}/export/${resource}.csv`, { credentials: "include" });
    if (!res.ok) return;
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || `${resource}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };
  if (render) return render({ onClick: download });
  return (
    <button
      onClick={download}
      data-testid={testid || `export-${resource}-csv`}
      className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest font-semibold text-slate-600 hover:text-[#EA580C] border border-slate-300 hover:border-[#EA580C] rounded-sm px-3 py-2 transition-colors"
    >
      <DownloadSimple size={14} /> CSV
    </button>
  );
}
